export default __webpack_public_path__ + "static/media/cost-forecasting-tab.ad4ae95b.png";